import React from "react";
import styles from "./styles.scss";
import { Props } from "./types";
import { useTranslation } from "react-i18next";
import { ResourceTypesFilter } from "./resourceTypesFilter";
import { Groups } from "./groups";

function ResourcesMenu({ filters, counts, setFilters }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.resourcesMenu}>
      <div className={styles.section}>
        <Groups filter={filters} setFilter={setFilters} />
      </div>
      <div className={styles.section}>
        <h3 className={styles.title}>
          {t("planzoneMembersPage.resourceTypesFilterTitle")}
        </h3>
        <ResourceTypesFilter
          counts={counts}
          types={filters.resourceTypes}
          inactiveOnly={filters.inactiveOnly}
          activeOnly={!!filters.activeOnly}
          setFilters={(resourceTypes) =>
            setFilters({ ...filters, resourceTypes })
          }
          // The activated and the deactivated resources exclude each other.
          setInactiveOnly={(inactiveOnly) =>
            setFilters({
              ...filters,
              inactiveOnly,
              activeOnly: inactiveOnly ? false : filters.activeOnly,
            })
          }
          setActiveOnly={(activeOnly) =>
            setFilters({
              ...filters,
              activeOnly,
              inactiveOnly: activeOnly ? false : filters.inactiveOnly,
            })
          }
        />
      </div>
    </div>
  );
}

export { ResourcesMenu };
